import { render, staticRenderFns } from "./SiloProfileInfoTable.vue?vue&type=template&id=a3468f0c&scoped=true&"
import script from "./SiloProfileInfoTable.vue?vue&type=script&lang=js&"
export * from "./SiloProfileInfoTable.vue?vue&type=script&lang=js&"
import style0 from "./SiloProfileInfoTable.vue?vue&type=style&index=0&id=a3468f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3468f0c",
  null
  
)

export default component.exports